import React, {useEffect, useState} from 'react'
import db from '../firebase'
import { Loader } from '../components/Loader'
import '../App.css'
import { Col, ListGroup, Row } from 'react-bootstrap'
import { RatingComponent } from '../components/RatingComponent'
import { v4 as uuidv4 } from 'uuid'
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import Aos from 'aos'
import 'aos/dist/aos.css'

export const HiremeScreen = () => {

    const Show = []

    const [cv, setCV] = useState('')
    const [tools, setTools] = useState([])
    const [toolRating, setToolRating] = useState([])
    const [tech, setTech] = useState([])
    const [techRating, setTechRating] = useState([])
    const [database, setDatabase] = useState([])
    const [databaseRating, setDatabaseRating] = useState([])
    const [helper, setHelper] = useState([])
    const [helperRating, setHelperRating] = useState([])
    const [exp, setExp] = useState([])
    const [padding, setPadding] = useState('p-5')

    const Tools = {}
    const Technologies = {}
    const Databases = {}
    const Other = {}

    const setObject = () => {
        tools.forEach((tool,index) => Tools[tool]=toolRating[index])
        tech.forEach((tech,index) => Technologies[tech]=techRating[index])
        database.forEach((db,index) => Databases[db]=databaseRating[index])
        helper.forEach((help,index) => Other[help]=helperRating[index])
        Show.push(Tools)
        Show.push(Technologies)
        Show.push(Databases)
        Show.push(Other)
    }

    useEffect(()=>{
        Aos.init({})
        if(typeof window==='object' && window.innerWidth<600){
            setPadding('p-3')
        }
        db.collection('education').doc('hire').get()
        .then((doc)=>{
            if(doc.exists){
                setTools(doc.data().tools)
                setToolRating(doc.data().toolRating)
                setTech(doc.data().technologies)
                setTechRating(doc.data().techRating)
                setDatabase(doc.data().databases)
                setDatabaseRating(doc.data().dbRating)
                setHelper(doc.data().helper)
                setHelperRating(doc.data().helpRating)
                setCV(doc.data().cv)
            }
        })
        db.collection('experiences').onSnapshot(snapShot => {
            setExp(snapShot.docs.map(doc => doc.data()).sort((a,b) => { return b.order - a.order }))
        })
    },[])
    
    const headings = ['Tools','Technologies','Databases','Other technologies']

    setObject()

    return <>
            {    
                helperRating.length===0 || exp.length===0
                ? <Loader/>
                :            
                    <div className={padding} style={{ textAlign:'left', margin:"4rem auto" }}>
                        <h3 data-aos="fade-down">Tools & Technologies...</h3>
                        <Row style={{ height:'100%' }} key={uuidv4()}>
                            {Show.map(s => (
                                <Col data-aos="fade-right" className='mb-2 mt-5' key={uuidv4()}>
                                    <h4 key={uuidv4()}>{headings[Show.indexOf(s)]}</h4>
                                    <ListGroup key={uuidv4()}>
                                        {Object.keys(s).map(key => (
                                            <ListGroup.Item className='border-0' style={{ padding:0 }} key={uuidv4()}>
                                                <RatingComponent rating={s[key]} item={key} key={uuidv4()}/>
                                            </ListGroup.Item>
                                        ))}
                                    </ListGroup>
                                </Col>
                            ))}
                        </Row>
                        <hr/>
                        <>
                            <h3>Experiences...</h3>
                            <ListGroup className='my-4 border-0' style={{backgroundColor:'rgb(31,31,31)', border:'1px solid rgba(52,52,52)', width:"100%"}}>
                            {typeof window==="object" && window.innerWidth>500 && exp ? exp.map(each => (
                                <ListGroup.Item className='hire_me_experience rounded' key={uuidv4()} style={{backgroundColor:'rgb(31,31,31)' }}>
                                    <div style={{ fontSize:"1.1rem" }}><span style={{ textDecoration:"underline" }}>Organization</span> : {each.organization}</div>
                                    <div style={{ fontSize:"1.1rem" }}><span style={{ textDecoration:"underline" }}>About</span> : {each.about}</div>
                                    <div style={{ fontSize:"1.1rem" }}><span style={{ textDecoration:"underline" }}>Role</span> : {each.role}</div>
                                    <div style={{ fontSize:"1.1rem" }}><span style={{ textDecoration:"underline" }}>Type</span> : {each.type}</div>
                                    <div style={{ fontSize:"1.1rem" }}><span style={{ textDecoration:"underline" }}>Tenure</span> : {each.start} - {each.end}</div>
                                    <div style={{ fontSize:"1.1rem" }}><span style={{ textDecoration:"underline" }}>Tasks</span> : [{each.tasks.map(e => (<span key={uuidv4()}>"{e}", </span>))}]</div>
                                    <div style={{ fontSize:"1.1rem" }}><span style={{ textDecoration:"underline" }}>Tech Stack</span> : [{each.tech.map(e => (<span key={uuidv4()}>"{e}", </span>))}]</div>
                                    {each.credential!=="" && <div style={{ fontSize:"1.1rem" }}><span style={{ textDecoration:"underline" }}>Credentials</span> : <a href={each.credential} target='_blank' rel="noopener noreferrer">Certificate</a></div>}
                                </ListGroup.Item>
                            ))
                            :
                            exp.map(each => (
                                <ListGroup.Item className='hire_me_experience rounded' key={uuidv4()} style={{backgroundColor:'rgb(31,31,31)'}}>
                                    <li style={{ fontSize:"1.1rem" }}>{each.organization}</li>
                                    <li style={{ fontSize:"1.1rem" }}>{each.role}</li>
                                    <li style={{ fontSize:"1.1rem" }}>{each.type}</li>
                                    <li style={{ fontSize:"1.1rem" }}>{each.start} - {each.end}</li>
                                    <li style={{ fontSize:"1.1rem" }}>{each.tech.map(e => (<span key={uuidv4()}>{e}, </span>))}</li>
                                    <li style={{ fontSize:"1.1rem" }}>{each.tasks.join(',')}</li>
                                    {each.credential!=="" && <li style={{ fontSize:"1.1rem" }}><a style={{ textDecoration:'underline' }} href={each.credential} target='_blank' rel="noopener noreferrer">Certificate</a></li>}
                                </ListGroup.Item>
                            ))
                            }
                            </ListGroup>
                        </>
                        <Row className='mt-3' >
                            <Col>
                                <Row className='px-3'>I have provided my Resume as a pdf document below.</Row>
                                <Row className='px-3'>Please feel free to contact me if you are interested in hiring. </Row>
                                <Row className='px-3'>Services I can provide :</Row> 
                                    <li>Frontend development {typeof window==='object' && window.innerWidth>500 && <span>( obvious from above skills )</span>}</li> 
                                    <li>Backend development{typeof window==='object' && window.innerWidth>500 ? <span> ( to some extent )</span> : <span>*</span>}</li>
                                    <li>Search Engine Optimization{typeof window==='object' && window.innerWidth>500 ? <span> ( beginner level )</span> : <span>*</span>}</li>
                                <ListGroup className='mt-3' style={{ backgroundColor:'rgb(31,31,31)' }}>
                                    <ListGroup.Item style={{border:"1px solid rgb(52,52,52)", width:'max-content', alignItems:'center', flexDirection:'row', backgroundColor:'rgb(31,31,31)', cursor:'pointer' }}>
                                        <a href={cv} download rel="noopener noreferrer" target="_blank" >
                                            <CloudDownloadIcon className='mr-2'/>
                                            <div style={{ display:'inline'}} >Download my resume</div>
                                        </a>
                                    </ListGroup.Item>
                                </ListGroup>
                            </Col>
                        </Row>
                    </div>
            }
        </>
}
